import { Select } from "./Form";

const StatusSelector = ({ ...rest }) => {
  return (
    <Select {...rest}>
      <option>🔴 Awaiting</option>
      <option>🟡 Processing</option>
      <option>🟢 Done</option>
    </Select>
  );
};

export default StatusSelector;
